export type UserAuthData = {
    email: string,
    password: string,
};

export type UserResetPasswordData = {
    password: string,
    confirmPassword: string
};

export type UserEmailData = Pick<UserAuthData, 'email'>;

export type UserPersonalInfoData = {
    email: string,
    name: string
};

export enum UserRoles {
    Default = 'default',
    Admin = 'admin',
}
